import { CustomerFlag } from './customer'

export enum CustomerTagSort {
  VALUE_ASC = 'value',
  VALUE_DSC = '-value',
  CREATED_ASC = 'created',
  CREATED_DSC = '-created',
  TYPE_ASC = 'type',
  TYPE_DSC = '-type',
  TYPE_VALUE_DSC = '-type value',
}

export enum CustomerTagType {
  SYSTEM = 'SYSTEM',
  CUSTOM = 'CUSTOM',
}

export enum CustomerTagEvent {
  CREATED = 'CUSTOMER_TAG_CREATED',
  UPDATED = 'CUSTOMER_TAG_UPDATED',
  DELETED = 'CUSTOMER_TAG_DELETED',
}

export const CUSTOMER_TAG_MAX_LENGTH = 50

export enum CustomerTagSystemValue {
  VIP = 'VIP',
  REGULAR = 'Regular',
  FRIENDS_WITH_OWNER = 'Friends with the Owner',
  BIG_SPENDER = 'Big Spender',
  TALENT = 'Talent',
  CELEBRITY = 'Celebrity',
  ATHLETE = 'Athlete',
  INFLUENCER = 'Influencer',
  MEMBER = 'Member',
  PROMOTER = 'Promoter',
  WARNING = 'Warning',
  BLOCKED = 'Blocked',
  EIGHTY_SIX = 'Eighty-Six (86)',
  FRAUD_LOW = 'Fraud - Low',
  FRAUD_MEDIUM = 'Fraud - Medium',
  FRAUD_HIGH = 'Fraud - High',
}

export const customerTagSystemIcons = {
  [CustomerTagSystemValue.VIP]: '⭐',
  [CustomerTagSystemValue.REGULAR]: '🙂',
  [CustomerTagSystemValue.FRIENDS_WITH_OWNER]: '👑🤝',
  [CustomerTagSystemValue.BIG_SPENDER]: '🤑',
  [CustomerTagSystemValue.TALENT]: '🎤',
  [CustomerTagSystemValue.CELEBRITY]: '⭐️',
  [CustomerTagSystemValue.ATHLETE]: '🏆',
  [CustomerTagSystemValue.INFLUENCER]: '📸',
  [CustomerTagSystemValue.MEMBER]: '🎟️',
  [CustomerTagSystemValue.PROMOTER]: '📣',
  [CustomerTagSystemValue.WARNING]: '⚠️',
  [CustomerTagSystemValue.BLOCKED]: '🚫',
  [CustomerTagSystemValue.EIGHTY_SIX]: '❌',
  [CustomerTagSystemValue.FRAUD_LOW]: '🛡️',
  [CustomerTagSystemValue.FRAUD_MEDIUM]: '⚠️',
  [CustomerTagSystemValue.FRAUD_HIGH]: '🚨',
}

export const customerTagSystemBackgroundColors = {
  //blue
  [CustomerTagSystemValue.VIP]: '#0095ff', //blue500
  [CustomerTagSystemValue.REGULAR]: '#0095ff', //blue500
  [CustomerTagSystemValue.FRIENDS_WITH_OWNER]: '#0095ff', //blue500
  [CustomerTagSystemValue.BIG_SPENDER]: '#0095ff', //blue500
  [CustomerTagSystemValue.TALENT]: '#0095ff', //blue500
  [CustomerTagSystemValue.CELEBRITY]: '#0095ff', //blue500
  [CustomerTagSystemValue.ATHLETE]: '#0095ff', //blue500
  [CustomerTagSystemValue.INFLUENCER]: '#0095ff', //blue500
  [CustomerTagSystemValue.MEMBER]: '#0095ff', //blue500
  //pink
  [CustomerTagSystemValue.PROMOTER]: '#ee46bc', //pink500
  //orange
  [CustomerTagSystemValue.WARNING]: '#d66700', //orange700
  //red
  [CustomerTagSystemValue.BLOCKED]: '#b42d2d', //red700
  [CustomerTagSystemValue.EIGHTY_SIX]: '#b42d2d', //red700
  [CustomerTagSystemValue.FRAUD_LOW]: '#0eaa4d', //green700
  [CustomerTagSystemValue.FRAUD_MEDIUM]: '#d66700', //orange700
  [CustomerTagSystemValue.FRAUD_HIGH]: '#b42d2d', //red700
}

export const customerTagSystemTextColors = {
  [CustomerTagSystemValue.VIP]: '#ffffff',
  [CustomerTagSystemValue.REGULAR]: '#ffffff',
  [CustomerTagSystemValue.FRIENDS_WITH_OWNER]: '#ffffff',
  [CustomerTagSystemValue.BIG_SPENDER]: '#ffffff',
  [CustomerTagSystemValue.TALENT]: '#ffffff',
  [CustomerTagSystemValue.CELEBRITY]: '#ffffff',
  [CustomerTagSystemValue.ATHLETE]: '#ffffff',
  [CustomerTagSystemValue.INFLUENCER]: '#ffffff',
  [CustomerTagSystemValue.MEMBER]: '#ffffff',
  [CustomerTagSystemValue.PROMOTER]: '#ffffff',
  [CustomerTagSystemValue.WARNING]: '#ffffff',
  [CustomerTagSystemValue.BLOCKED]: '#ffffff',
  [CustomerTagSystemValue.EIGHTY_SIX]: '#ffffff',
  [CustomerTagSystemValue.FRAUD_LOW]: '#ffffff',
  [CustomerTagSystemValue.FRAUD_MEDIUM]: '#ffffff',
  [CustomerTagSystemValue.FRAUD_HIGH]: '#ffffff',
}

// System Tag Colors and Emojis (optimized for dark mode)
// Regular	#0095ff	#ffffff	🙂
// Friends with the Owner	#0095ff	#ffffff	👑🤝
// Big Spender	#1ecc64	#ffffff	🤑
// Talent	#0095ff	#ffffff	🎤
// Celebrity	#0095ff	#ffffff	⭐️
// Athlete	#0095ff	#ffffff	🏆
// Influencer	#0095ff	#ffffff	📸
// Member	#4c4cd3	#ffffff	🎟️
// Promoter	#0095ff	#ffffff	📣
// Warning	#ff922e	#ffffff	⚠️
// Blocked	#f85454	#ffffff	🚫
// Eighty-Six	#f85454	#ffffff	❌

export const customerTagSystemReservedValues: CustomerTagSystemValue[] =
  Object.values(CustomerTagSystemValue)

export const customerTagMachineManagedFraudValues: CustomerTagSystemValue[] = [
  CustomerTagSystemValue.FRAUD_LOW,
  CustomerTagSystemValue.FRAUD_MEDIUM,
  CustomerTagSystemValue.FRAUD_HIGH,
]

export const customerTagMachineManagedStripeValues =
  customerTagMachineManagedFraudValues

export const getCustomerTagSystemProps = (value: CustomerTagSystemValue) => {
  return {
    value,
    backgroundColor: customerTagSystemBackgroundColors[value],
    textColor: customerTagSystemTextColors[value],
    icon: customerTagSystemIcons[value],
    type: CustomerTagType.SYSTEM,
  }
}

export const customerFlagToSystemValueMap: Record<
  CustomerFlag,
  CustomerTagSystemValue
> = {
  [CustomerFlag.REGULAR]: CustomerTagSystemValue.REGULAR,
  [CustomerFlag.FRIENDS_WITH_OWNER]: CustomerTagSystemValue.FRIENDS_WITH_OWNER,
  [CustomerFlag.BIG_SPENDER]: CustomerTagSystemValue.BIG_SPENDER,
  [CustomerFlag.TALENT]: CustomerTagSystemValue.TALENT,
  [CustomerFlag.CELEBRITY]: CustomerTagSystemValue.CELEBRITY,
  [CustomerFlag.ATHLETE]: CustomerTagSystemValue.ATHLETE,
  [CustomerFlag.INFLUENCER]: CustomerTagSystemValue.INFLUENCER,
  [CustomerFlag.MEMBER]: CustomerTagSystemValue.MEMBER,
  [CustomerFlag.PROMOTER]: CustomerTagSystemValue.PROMOTER,
  [CustomerFlag.WARNING]: CustomerTagSystemValue.WARNING,
  [CustomerFlag.BLOCKED]: CustomerTagSystemValue.BLOCKED,
  [CustomerFlag.EIGHTY_SIX]: CustomerTagSystemValue.EIGHTY_SIX,
}
